const minimumSearchLength = 3;
export function isValidSearchLength(searchTerm: string): boolean {
  return searchTerm.length >= minimumSearchLength;
}

type CountDisplayParams = {
  count: number | undefined;
  singular: string;
  plural: string;
};
/**
 * Returns a string representation of a count, with the appropriate singular or
 * plural word based on the count.
 *
 * @param {CountDisplayParams} - An object containing the count value and
 *   singular/plural words
 * @returns {string} - The string representation of the count
 * @throws {Error} - If the count value is not a number or is not defined
 */
export function countDisplay({
  count,
  plural,
  singular,
}: CountDisplayParams): string {
  if (count === undefined || typeof count !== 'number') {
    throw new Error(
      `Invalid count value for '${singular}', found ${{ count }}`,
    );
  }

  switch (count) {
    case 0:
      return `No ${plural}`;
    case 1:
      return `1 ${singular}`;
    default:
      return `${count} ${plural}`;
  }
}

/** Take a URL and extract the filename and extension from it */
export function extractFilename(str: string): string {
  return str.substring(str.lastIndexOf('/') + 1);
}
